/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_PrefixInputs */

const en_auth_legal_prefix = /** @type {(inputs: Auth_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By continuing, you agree to the`)
};

const pl_auth_legal_prefix = /** @type {(inputs: Auth_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontynuując, akceptujesz`)
};

/**
* | output |
* | --- |
* | "By continuing, you agree to the" |
*
* @param {Auth_Legal_PrefixInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_legal_prefix = /** @type {((inputs?: Auth_Legal_PrefixInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_PrefixInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_legal_prefix(inputs)
	return en_auth_legal_prefix(inputs)
});